import { Box } from '@mui/material';
import Header from '../Header/Header';
import ScrollTop from '../ScrollTop/ScrollTop';

const Layout = ({ children }) => {
  return (
    <Box>
      <Header />
      <Box component="main">
        {children}
      </Box>
      <ScrollTop />
    </Box>
  );
};

export default Layout;
